import { useQuery } from '@tanstack/react-query';
import { CampaignsService } from '../services';
import { campaignsKeys } from '../queryKeys';
import { READ_ONLY_QUERY_OPTIONS } from '../queryConfig';

/**
 * Every discount campaign as promo-code rows, for the Promo Codes list.
 *
 * One query for the whole set: search, the status filter and paging are all
 * client-side (see promoCodes.js), so they change what is *shown*, never what
 * is fetched, and a keystroke never costs a request. `retry: false` keeps a
 * campaign-service outage from stalling the page behind three retries.
 */
export const usePromoCodes = () => {
  const { data, error, isError, isPending, isFetching } = useQuery({
    queryKey: campaignsKeys.promoCodes(),
    queryFn: () => CampaignsService.getPromoCodes(),
    ...READ_ONLY_QUERY_OPTIONS,
  });

  return {
    promoCodes: data ?? [],
    isPending,
    isFetching,
    isError,
    error,
  };
};
